module.exports = __webpack_public_path__ + "8b6ea8f017b815871b0986b7038dcb80.png";